import { type Dispatch, type SetStateAction, createContext } from "react";

import type { SmartHistoryQueue } from "./SmartHistoryQueue";

const SmartHistoryContext = createContext<null | [SmartHistoryQueue, Dispatch<SetStateAction<SmartHistoryQueue>>]>(
	null,
);

const CONTEXT_PROVIDER_NAME = "SmartHistoryBoundary";

export { CONTEXT_PROVIDER_NAME, SmartHistoryContext };
